import { normalizeBrazilianDocument } from './normalize';
import { CNPJ_BASE_LENGTH, CNPJ_LENGTH } from './types';

/** Valor numérico do caractere para cálculo do DV (Receita/Serpro: código ASCII − 48). */
export function cnpjCharValue(char: string): number {
  return char.toUpperCase().charCodeAt(0) - 48;
}

/** Pesos 2–9 da direita para a esquerda, reiniciando após o 8º caractere. */
export function cnpjWeights(length: number): number[] {
  const weights = new Array<number>(length);
  let weight = 2;

  for (let index = length - 1; index >= 0; index--) {
    weights[index] = weight;
    weight++;
    if (weight > 9) {
      weight = 2;
    }
  }

  return weights;
}

function calculateCnpjCheckDigit(base: string): number {
  const weights = cnpjWeights(base.length);
  let sum = 0;

  for (let index = 0; index < base.length; index++) {
    sum += cnpjCharValue(base[index]) * weights[index];
  }

  const remainder = sum % 11;
  return remainder === 0 || remainder === 1 ? 0 : 11 - remainder;
}

/**
 * Valida CNPJ numérico ou alfanumérico (12 alfanum + 2 DVs numéricos).
 * Algoritmo: módulo 11 com pesos 2–9 (Receita Federal / Serpro).
 */
export function validateCnpj(value: string | null | undefined): boolean {
  const cnpj = normalizeBrazilianDocument(value);
  if (cnpj.length !== CNPJ_LENGTH) {
    return false;
  }
  if (!/^[0-9A-Z]{12}\d{2}$/.test(cnpj)) {
    return false;
  }

  const base = cnpj.substring(0, CNPJ_BASE_LENGTH);
  const firstDigit = calculateCnpjCheckDigit(base);
  const secondDigit = calculateCnpjCheckDigit(base + firstDigit);
  const expected = `${firstDigit}${secondDigit}`;

  return cnpj.endsWith(expected);
}
